import { createAction } from 'redux-actions';
import * as actions from 'typings/actions';
import { LoadingStatesActionType } from 'actions/actionTypes';

export const reset = createAction<actions.ResetLoadingStateAction, any>(
  LoadingStatesActionType.RESET
);
